import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "DocumentLine" }
const _hoisted_2 = {
  key: 0,
  class: "DocumentLine__handle"
}
const _hoisted_3 = {
  key: 1,
  class: "DocumentLine__tools"
}

import { computed, PropType, watch } from "vue";
import { Document, Line } from "@/types";
import DocumentLineAmount from "@/components/pages/document/parts/lines/DocumentLineAmount.vue";
import DocumentLineEnter from "@/components/pages/document/parts/lines/DocumentLineEnter.vue";
import DocumentLineCount from "@/components/pages/document/parts/lines/DocumentLineCount.vue";
import DocumentLineText from "@/components/pages/document/parts/lines/DocumentLineText.vue";
import { useDebounceFn } from "@vueuse/core";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import Icon from "@/components/ds/icon/Icon.vue";
import DocumentLineDelete from "@/components/pages/document/parts/lines/DocumentLineDelete.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLine',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    line: {
        type: Object as PropType<Line>,
        required: true,
    },
    locked: {
        type: Boolean,
        required: true,
    },
    currency: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const components = {
    DocumentLineAmount,
    DocumentLineEnter,
    DocumentLineCount,
    DocumentLineText,
};

const component = computed(() => {
    switch (props.line.lineType) {
        case "amount":
            return components.DocumentLineAmount;
        case "count":
            return components.DocumentLineCount;
        case "enter":
            return components.DocumentLineEnter;
        case "text":
            return components.DocumentLineText;
        default:
            return DocumentLineEnter;
    }
});

const debouncedFn = useDebounceFn(() => {
    if (props.line) {
        api.update(props.line, "documentLines").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

watch(
    () => props.line,
    () => {
        debouncedFn();
    },
    { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
      line: __props.line,
      locked: __props.locked,
      currency: __props.currency
    }, null, 8, ["line", "locked", "currency"])),
    (!__props.locked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Icon, { "icon-id": "bars" })
        ]))
      : _createCommentVNode("", true),
    (!__props.locked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(DocumentLineDelete, {
            document: __props.document,
            line: __props.line
          }, null, 8, ["document", "line"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})